import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="row">
        <div>
          <img
            src={`${process.env.PUBLIC_URL}/ann-lockup-cyan.svg`}
            alt="Ann"
            className="ann-logo ann-logo-footer"
          />
          <p className="foot-blurb">
            Hiring intelligence. The first that understands hiring — for any
            role, any team.
          </p>
          <p className="foot-copy">© 2026 ANN LABS</p>
        </div>

        <div>
          <h5>Product</h5>
          <ul>
            <li><Link to="/how-it-works">How it works</Link></li>
            <li><Link to="/why-ann">Why Ann</Link></li>
            <li><Link to="/compare">Compare</Link></li>
            <li><Link to="/pricing">Pricing</Link></li>
          </ul>
        </div>

        <div>
          <h5>For your team</h5>
          <ul>
            <li><Link to="/for/founders">Founders</Link></li>
            <li><Link to="/for/heads-of-ta">Heads of TA</Link></li>
            <li><Link to="/for/chros">CHROs</Link></li>
            <li><Link to="/for/staffing-firms">Staffing &amp; agencies</Link></li>
          </ul>
        </div>

        <div>
          <h5>Company</h5>
          <ul>
            <li><Link to="/ann-effect">The Ann effect</Link></li>
            <li><Link to="/resource">Resources</Link></li>
            <li><Link to="/careers">Careers</Link></li>
          </ul>
        </div>

        <div>
          <h5>Stay in touch</h5>
          <ul>
            <li>
              <a href="https://www.linkedin.com/company/annai/" target="_blank" rel="noreferrer">
                LinkedIn
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="legal">
        <span>The first hiring tool that understands hiring.</span>
        <div className="legal-links">
          <Link to="/trust">Trust</Link>
          <Link to="/privacy-policy">Privacy</Link>
          <Link to="/terms-and-coniditon">Terms</Link>
        </div>
      </div>
    </footer>
  );
}
